<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<template>
  <footer>
    <BContainer fluid style="background-color: #1c1c1c;">
      <BRow>
        <BCol class="d-flex justify-content-center align-items-center">                                 
          <p class="my-2"> 
            © Copyright 2020-{{ currentYear }} CYBETOWER® | Servizio offerto da 
            <a href="https://cybetower.swiss" target="_blank">cybetower.swiss</a> | 
            CYBETOWER® è un marchio registrato | All Rights Reserved | 
            <a href="https://cybetower.swiss/it/privacy_policy/" target="_blank">Privacy policy</a>
          </p>
        </BCol>
      </BRow>
    </BContainer>
  </footer>
</template>

<style scoped>
a {
  color: #0000FF;
}
</style>
